export enum PatientColorMap {
  Default = `var(--default, #243443)`,
  DefaultLight = "var(--default-light, #F7F7F9)",
  DefaultDark = "var(--default-dark, #AAB0B7)",
  Primary = "var(--primary)",
  PrimaryLight = "var(--primary-light)",
  PrimaryDark = "var(--primary-dark)",
  Secondary = "var(--secondary)",
  Background = "var(--background)",
  Background2 = "var(--background2)",
  Red = "var(--red)",
  Emergency = "var(--emergency)",
  EmergencyLight = "var(--emergency-light)",
  Urgent = "var(--urgent)",
  UrgentLight = "var(--urgent-light)",
  NotUrgent = "var(--not-urgent)",
  NotUrgentLight = "var(--not-urgent-light)",
  Orange = "var(--orange)",
  Green = "var(--green)",
  Disabled = "var(--disabled)",
  Selected = "var(--selected)",
  AfterClick = "var(--after-click)",
  AfterClickText = "var(--after-click-text)",
  Unselected = "var(--unselected)",
  GradLight = "var(--grad-light)",
  GradDark = "var(--grad-dark)",
  Header = "var(--header)",
  DisabledText = "var(--disabled-text)",
  OrganMapBackground = "var(--organ-map-background)",
  SymptomIconBackground = "var(--symptom-icon-background)",
  SymptomCharacterColor = "var(--symptom-character-color)",
  SymptomDarkBodyLines = "var(--symptom-dark-body-lines)",
  SymptomLightBodyLines = "var(--symptom-light-body-lines)",
  White = "var(--white)",
  HomepageTextColor = "var(--homepage-text-color)",
  Undo = "var(--undo)",
  HomepageLinkColor = "var(--homepage-link-color)",
  AnswerTextColor = "var(--answer-text-color)",
  TermsLinkColor = "var(--terms-link-color)",
  ButtonTextColor = "var(--button-text-color)",
}
